import React from 'react';
import { Form } from 'react-bootstrap';

interface ConnectionSSHProps {
  connectionData: any;
  handleParameterChange: (key: string, value: any) => void;
}

const ConnectionSSH: React.FC<ConnectionSSHProps> = ({ connectionData, handleParameterChange }) => {
  return (
    <>
      <Form.Group controlId="sshCommand" className="mb-3">
        <Form.Label>SSH Command</Form.Label>
        <Form.Control
          type="text"
          value={connectionData.connection_parameters.ssh_command || ''}
          onChange={(e) => handleParameterChange('ssh_command', e.target.value)}
          placeholder="e.g. ssh -i ~/.ssh/id_rsa ...."
        />
        <Form.Text className="text-muted">
          This command is forwarded to the agent when shell nodes run through the SSH connection, including Windows targets reached over OpenSSH.
        </Form.Text>
      </Form.Group>

      <Form.Group controlId="sshUser" className="mb-3">
        <Form.Label>User</Form.Label>
        <Form.Control
          type="text"
          value={connectionData.connection_parameters.user || ''}
          onChange={(e) => handleParameterChange('user', e.target.value)}
          placeholder="e.g. deploy"
        />
        <Form.Text className="text-muted">
          Optional. When a node has <em>Run as user</em> set, the scheduler uses this field to select the matching SSH connection from the queue. Leave blank if
          this connection should be used regardless of user.
        </Form.Text>
      </Form.Group>

      <Form.Group controlId="sshShell" className="mb-3">
        <Form.Label>SSH Shell</Form.Label>
        <Form.Control
          as="select"
          value={connectionData.connection_parameters.ssh_shell || 'bash'}
          onChange={(e) => handleParameterChange('ssh_shell', e.target.value)}
        >
          <option value="bash">bash</option>
          <option value="ksh">ksh</option>
          <option value="sh">sh</option>
          <option value="pwsh">pwsh</option>
          <option value="cmd">cmd</option>
        </Form.Control>
        <Form.Text className="text-muted">
          Default remote shell <b>only</b> used by SSH-based file events.
        </Form.Text>
      </Form.Group>

      <Form.Group controlId="sshPreExecutionScript" className="mb-3">
        <Form.Label>Pre-running Script</Form.Label>
        <Form.Control
          as="textarea"
          rows={6}
          value={connectionData.connection_parameters.pre_execution_script || ''}
          onChange={(e) => handleParameterChange('pre_execution_script', e.target.value)}
          placeholder="Optional script executed on SSH target before node script."
        />
        <Form.Text className="text-muted">
          Runs in the selected node sub type on the SSH target, so use shell syntax that matches `bash`, `ksh`, `cmd`, or `pwsh`.
        </Form.Text>
      </Form.Group>
    </>
  );
};

export default ConnectionSSH;
